import {
    createSkyNetObjectRoutes,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.utils'

import ServiceCentersDemoPage from './ServiceCentersDemoPage'
import domainConfig from './ServiceCentersDemo.config'

export default createSkyNetObjectRoutes(<ServiceCentersDemoPage />, domainConfig)
